import React, { useState, useEffect } from "react";
import "../../assets/css/views/schedulingAgendas/schedulingAgendas.css";
import { useTranslation } from "react-i18next";
import {
  Select,
  Button,
  IconDocumentCopy,
  TableData,
  SelectOption,
  ContextualMenu,
  IconPencil,
  IconTrash,
  Checkbox,
  Modal,
  ButtonGroup,
  DatePicker,
  DateRange,
  OptionInterface,
} from "@veneer/core";

import { createTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { ThemeProvider } from "@mui/material/styles";

import appointmentService from "../../services/agendaApi/appointment.service";
import AgendaCalendar from "../../components/AgendaCalendar/AgendaCalendar";
import {
  ICalendarEvent,
  DeleteOccurrenceMode,
  IDeleteSeriesPayload,
  IDeleteOccurrencePayload,
  isPastAppointmentOccurrence,
  parseLocalDate,
  buildSelectableOccurrences,
} from "../../components/AgendaCalendar/agendaCalendarUtils";
import DeleteOccurrenceModal from "../../components/AgendaCalendar/DeleteOccurrenceModal";

import { ITypeOfAppointmentDto } from "../../models/dto/agendaApi/ITypeOfAppointmentDto";
import { ISubretailDto } from "../../models/dto/agendaApi/ISubretailDto";
import {
  IPointOfSaleByCoordinatesDto,
  IPointOfSaleByListDto,
} from "../../models/dto/agendaApi/IPointOfSaleDto";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { decryptText } from "../../utils/encryptionUtils";
import { truncatePosLabel } from "../../utils/conversion";
import AgendaManagement from "../../services/agendaApi/agendaManagement";
import { IGetStateListDto } from "../../models/dto/userManagementApi/IGetStateListDto";
import { IGetCityListDto } from "../../models/dto/userManagementApi/IGetCityListDto";
import { IGetAdviserListDto } from "../../models/dto/agendaApi/IGetAdviserListDto";
import { IGetAppointmentOccurrenceByUser, IOccurrenceDetail } from "../../models/dto/agendaApi/IGetAppointmentsByUser";
import { AgendaCreationBlock } from "./AgendasComponent/AgendaCreationBlock";
import { IUpdateAppoiment } from "../../models/input/agendaApi/IUpdateAppoiment";
import { IUpdateAppointmentOccurrencesDto, IUpdateSingleOccurrenceDto } from "../../models/dto/agendaApi/IAppointmentControlDto";
import { AgendaEditingBLock } from "./AgendasComponent/AgendaEditingBLock";
import { ModalMessageAgenda } from "./AgendasComponent/ModalMessageAgenda";
import WeeklyAgendaModal from "./AgendasComponent/WeeklyAgendaModal";
import useSearchSelect from "../../hooks/searchSelect/useSearchSelect";
import { AppointmentTypeEnum } from "../../models/enum/AgendaApi/AppointmentTypeEnum";
import {
  MAX_OCCURRENCE_SCAN_DAYS,
} from "./agendaConstants";

export default function SchedulingAgendas() {
  const [t] = useTranslation("global");
  const { handleSearch } = useSearchSelect();

  const languageID: any = useSelector((state: RootState) => state.languageId);

  type SelectValue = number | string | boolean; //CHECK

  //Disables
  const [disableAdvisor, setDisableAdvisor] = useState(true);
  const [addAgendaButtonDisable, setAddAgendaButtonDisable] = useState(true);
  const [editAgendaButtonDisable, setEditAgendaButtonDisable] = useState(true);
  const [disableTypeOfVisit, setDisableTypeOfVisit] = useState(true);
  const [disableSubretail, setDisableSubretail] = useState(true);
  const [disablePointOfSale, setDisablePointOfSale] = useState(true);
  const [openAddAgendaDisable, setOpenAddAgendaDisable] = useState(true);
  const state: any = useSelector((state: RootState) => state.user);

  //Data
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [, setTableFilteredData] = useState<TableData[]>([]);
  const [typeofAppointmentData, setTypeofAppointmentData] = useState<
    SelectOption[]
  >([]);
  const [typeofAppointmentDataCopy, setTypeofAppointmentDataCopy] = useState<
    SelectOption[]
  >([]);
  const [subretailData, setSubretailData] = useState<SelectOption[]>([]);
  const [subretailDataCopy, setSubretailDataCopy] = useState<SelectOption[]>(
    []
  );
  const [pointOfSaleData, setPointOfSaleData] = useState<SelectOption[]>([]);
  const [pointOfSaleDataCopy, setPointOfSaleDataCopy] = useState<
    SelectOption[]
  >([]);
  const [valueState, setValueState] = useState<number[]>([]);
  const [valueCity, setValueCity] = useState<number[]>([]);
  const [valueAdviser, setValueAdviser] = useState<number[]>([]);

  //Errors
  const [errorPos, setErrorPos] = useState<boolean>(false);
  const [errorDatePicker, setErrorDatePicker] = useState<boolean>(false);

  //Valid
  const [isValidCoordinates, setIsValidCoordinates] = useState(false);
  const [isStateValid, setIsStateValid] = useState<boolean>(true);

  //Selects
  const [typeOfVisit, setTypeOfVisit] = useState<SelectValue[]>([]);
  const [typeOfVisitId, setTypeOfVisitId] = useState<number>(NaN);
  const [subRetail, setSubRetail] = useState<SelectValue[]>([]);
  const [pointOfSale, setPointOfSale] = useState<SelectValue[]>([]);
  const [appointmentSelected, setAppointmentSelected] = useState<number>(NaN);
  const [optionsState, setOptionsState] = useState<SelectOption[]>([]);
  const [optionsStateCopy, setOptionsStateCopy] = useState<SelectOption[]>([]);
  const [optionsCity, setOptionsCity] = useState<SelectOption[]>([]);
  const [optionsCityCopy, setOptionsCityCopy] = useState<SelectOption[]>([]);
  const [optionsAdviser, setOptionsAdviser] = useState<SelectOption[]>([]);
  const [optionsAdviserCopy, setOptionsAdviserCopy] = useState<SelectOption[]>(
    []
  );

  //Dates
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [visitDate, setVisitDate] = useState<string>("");

  //Textbox
  const [startTime, setStartTime] = useState<string | moment.Moment | null>(
    null
  );
  const [endTime, setEndTime] = useState<string | moment.Moment | null>(null);

  //Checkbox
  const [checkboxMonday, setCheckboxMonday] = useState(false);
  const [checkboxTuesday, setCheckboxTuesday] = useState(false);
  const [checkboxWednesday, setCheckboxWednesday] = useState(false);
  const [checkboxThursday, setCheckboxThursday] = useState(false);
  const [checkboxFriday, setcheckboxFriday] = useState(false);
  const [checkboxSaturday, setCheckboxSaturday] = useState(false);
  const [checkboxSunday, setCheckboxSunday] = useState(false);

  //Raw appointments for calendar
  const [rawAppointments, setRawAppointments] = useState<IGetAppointmentOccurrenceByUser[]>([]);

  //Shows
  const [showModalAddAgenda, setShowModalAddAgenda] = useState(false);
  const [showModalDeleteAgenda, setShowModalDeleteAgenda] = useState(false);
  const [showModalEditAgendaPermanent, setShowModalEditAgendaPermanent] =
    useState(false);
  const [showModalEditAgendaVisit, setShowModalEditAgendaVisit] =
    useState(false);
  const [showModalEditOccurrences, setShowModalEditOccurrences] =
    useState(false);

  // ── Delete state ──────────────────────────────────────────────────────────
  const [deleteSeriesPayload, setDeleteSeriesPayload] = useState<IDeleteSeriesPayload | null>(null);
  const [showDeleteOccurrenceModal, setShowDeleteOccurrenceModal] = useState(false);
  const [showModalWeeklyAgenda, setShowModalWeeklyAgenda] = useState(false);
  const [deleteOccurrenceMode, setDeleteOccurrenceMode] = useState<DeleteOccurrenceMode | null>(null);
  const [selectedDeleteEvent, setSelectedDeleteEvent] = useState<ICalendarEvent | null>(null);

  const [occurrenceOptions, setOccurrenceOptions] = useState<SelectOption[]>([]);
  const [selectedOccurrenceDates, setSelectedOccurrenceDates] = useState<string[]>([]);
  const [currentEditOccurrenceValue, setCurrentEditOccurrenceValue] = useState<string>('');
  const [isOccurrenceTodayForEdit, setIsOccurrenceTodayForEdit] = useState<boolean>(false);
  // Occurrence date from the calendar event used as reference for time validation in Edit Series
  const [editSeriesOccurrenceDate, setEditSeriesOccurrenceDate] = useState<string | null>(null);
  // Dedicated error state for the "Edit by occurrences" modal (isolated from sub-components)
  const [occStartTimeErrorReason, setOccStartTimeErrorReason] = useState<string | null>(null);
  const [occEndTimeErrorReason, setOccEndTimeErrorReason] = useState<string | null>(null);
  // Shared error state passed down to AgendaCreationBlock / AgendaEditingBLock
  const [startTimeErrorReason, setStartTimeErrorReason] = useState<string | null>(null);
  const [endTimeErrorReason, setEndTimeErrorReason] = useState<string | null>(null);

  //Create, update and delete message
  const [openMessageError, setOpenMessageError] = useState(false);
  const [openMessageCreatedAgenda, setOpenMessageCreatedAgenda] =
    useState(false);
  const [openMessageExistingAgenda, setOpenMessageExistingAgenda] =
    useState(false);
  const [openMessageUpdateAgenda, setOpenMessageUpdateAgenda] = useState(false);
  const [openMessageExpiredAgenda, setOpenMessageExpiredAgenda] =
    useState(false);
  const [openMessageDeleteAgenda, setOpenMessageDeleteAgenda] = useState(false);
  const [
    openMessageToDeleteAgendaWithCheckIn,
    setOpenMessageToDeleteAgendaWithCheckIn,
  ] = useState(false);
  const [openMessageStartDateError, setOpenMessageStartDateError] =
    useState(false);
  const [openMessagePastOccurrenceRestricted, setOpenMessagePastOccurrenceRestricted] =
    useState(false);
  const [openMessageCheckedInRestricted, setOpenMessageCheckedInRestricted] =
    useState(false);

  const [formCreateAppoiment, setFormCreateAppoiment] = useState({
    UserID: 0,
    PosCode: "",
    DateStart: "",
    DateEnd: "",
    DateVisit: "",
    AssignHourIn: "",
    AssignHourOut: "",
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
    Sunday: false,
    AppointmentTypeID: 0,
  });

  const theme = createTheme({
    palette: {
      primary: {
        main: "#027aae",
      },
    },
  });

  useEffect(() => {
    getStateByCountry(Number(decryptText(state.user.countryId)));
    setDisableAdvisor(false);
    getAdvisorsBySupervisors(0);
    if (valueAdviser.length > 0) {
      getAppointmentsByUser(valueAdviser[0], languageID.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageID]);

  useEffect(() => {
    if (!appointmentSelected) {
      setSubRetail([]);
      setPointOfSale([]);
      setStartTime(null);
      setEndTime(null);
      setStartDate("");
      setEndDate("");
      setVisitDate("");
      setCheckboxMonday(false);
      setCheckboxTuesday(false);
      setCheckboxWednesday(false);
      setCheckboxThursday(false);
      setcheckboxFriday(false);
      setCheckboxSaturday(false);
      setCheckboxSunday(false);
      setErrorDatePicker(false);
      setErrorPos(false);
      setIsValidCoordinates(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeOfVisit]);

  useEffect(() => {
    if (subRetail.length > 0 && pointOfSale.length > 0) {
      getPosCoordinates();
    } else {
      // Reset coordinates so re-selection triggers a false→true transition in isValidCoordinates,
      // ensuring the addAgendaButtonDisable effect re-evaluates after the next getPosCoordinates call.
      setIsValidCoordinates(false);
      setAddAgendaButtonDisable(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subRetail, pointOfSale]);

  const ValidateCoordinates = (
    posCoordinates: Array<IPointOfSaleByCoordinatesDto>
  ) => {
    let posWithouthCoordinate = posCoordinates.some(function (pos) {
      return pos.latitude === null || pos.longitude === null;
    });
    return posWithouthCoordinate;
  };

  const getPosCoordinates = () => {
    appointmentService
      .getPosCoordinates(String(pointOfSale))
      .then((r) => {
        let isNotValid = ValidateCoordinates(r);
        if (isNotValid) {
          setErrorPos(true);
          setIsValidCoordinates(false);
          setAddAgendaButtonDisable(true);
        } else {
          setErrorPos(false);
          setIsValidCoordinates(true);
        }
      })
      .catch(() => {
        setErrorPos(true);
        setIsValidCoordinates(false);
        setAddAgendaButtonDisable(true);
      });
  };

  const isTimeValid = (t: string | moment.Moment | null): boolean =>
    t !== null && moment(t).isValid();

  const isVisitType =
    Number(typeOfVisit) === AppointmentTypeEnum.Visit ||
    Number(typeOfVisit) === AppointmentTypeEnum.VisitAlt;

  // Mirror the minTime logic in AgendaCreationBlock: if the reference date is today,
  // start time must not be before the current minute.
  const referenceDate = isVisitType ? visitDate : startDate;
  const isStartTimeTooEarly =
    !!referenceDate &&
    moment(referenceDate).isSame(moment(), "day") &&
    isTimeValid(startTime) &&
    moment(startTime).isBefore(moment(), "minute");

  const timesAreValid =
    isTimeValid(startTime) &&
    isTimeValid(endTime) &&
    !moment(startTime).isSame(moment(endTime), "minute") &&
    !isStartTimeTooEarly;

  useEffect(() => {
    if (Number(typeOfVisit) === AppointmentTypeEnum.Visit || Number(typeOfVisit) === AppointmentTypeEnum.VisitAlt) {
      if (
        isValidCoordinates === true &&
        visitDate !== "" &&
        timesAreValid
      ) {
        setAddAgendaButtonDisable(false);
      } else {
        setAddAgendaButtonDisable(true);
      }
    } else {
      if (
        isValidCoordinates === true &&
        startDate !== "" &&
        endDate !== "" &&
        timesAreValid
      ) {
        if (
          checkboxMonday === true ||
          checkboxTuesday === true ||
          checkboxWednesday === true ||
          checkboxThursday === true ||
          checkboxFriday === true ||
          checkboxSaturday === true ||
          checkboxSunday === true
        ) {
          setAddAgendaButtonDisable(false);
        } else {
          setAddAgendaButtonDisable(true);
        }
      } else {
        setAddAgendaButtonDisable(true);
      }
    }
  }, [
    isValidCoordinates,
    typeOfVisit,
    startDate,
    endDate,
    visitDate,
    startTime,
    endTime,
    timesAreValid,
    checkboxMonday,
    checkboxTuesday,
    checkboxWednesday,
    checkboxThursday,
    checkboxFriday,
    checkboxSaturday,
    checkboxSunday,
    errorDatePicker,
  ]);

  useEffect(() => {
    const missingSelections = subRetail.length === 0 || pointOfSale.length === 0;
    const hasTimeError = !!startTimeErrorReason || !!endTimeErrorReason;
    if (Number(typeOfVisit) === AppointmentTypeEnum.Visit || Number(typeOfVisit) === AppointmentTypeEnum.VisitAlt) {
      // mirrors isOutsideRange: past/invalid dates are treated as unset
      const visitDateInvalid = !visitDate || !moment(visitDate).isValid() || moment(visitDate).isBefore(moment(), 'day');
      setEditAgendaButtonDisable(
        missingSelections || !isValidCoordinates || visitDateInvalid || !timesAreValid || hasTimeError || errorDatePicker
      );
    } else {
      const hasDay =
        checkboxMonday || checkboxTuesday || checkboxWednesday ||
        checkboxThursday || checkboxFriday || checkboxSaturday || checkboxSunday;
      setEditAgendaButtonDisable(
        missingSelections || !isValidCoordinates || startDate === "" || endDate === "" ||
        !timesAreValid || hasTimeError || !hasDay || errorDatePicker
      );
    }
  }, [
    subRetail,
    pointOfSale,
    isValidCoordinates,
    typeOfVisit,
    visitDate,
    startDate,
    endDate,
    startTime,
    endTime,
    timesAreValid,
    startTimeErrorReason,
    endTimeErrorReason,
    checkboxMonday,
    checkboxTuesday,
    checkboxWednesday,
    checkboxThursday,
    checkboxFriday,
    checkboxSaturday,
    checkboxSunday,
    errorDatePicker,
  ]);

  //Peticiones
  const getTypeOfAppointmentListByRoleType = () => {
    appointmentService
      .getTypeOfAppointmentListByRoleType(2, languageID.value)
      .then((r: any) => {
        fillDataTypeOfAppointment(r);
      })
      .finally(() => {
        setDisableTypeOfVisit(false);
      });
  };

  const getSubretail = () => {
    setDisableSubretail(false);
    appointmentService
      .getSubretailList()
      .then((r: any) => {
        fillDataSubretail(r);
      });
  };

  const getPointOfsale = (subretailId: number) => {
    setDisablePointOfSale(false);
    appointmentService
      .getPosListBySubretailList(String(subretailId))
      .then((r: any) => {
        fillDataPointOfSale(r);
      });
  };

  const getPointOfsaleByList = (values: string) => {
    setDisablePointOfSale(false);
    appointmentService
      .getPosListBySubretailList(values)
      .then((r: any) => {
        fillDataPointOfSale(r);
      });
  };

  const getStateByCountry = (countryID: number) => {
    AgendaManagement.getStateByCountry(countryID)
      .then((result: IGetStateListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.stateID,
          label: item.stateName,
        }));
        setOptionsState(updatedOptions);
        setOptionsStateCopy(updatedOptions);
      })
      .catch(() => setOpenMessageError(true));
  };

  const getCityByState = (stateID: number) => {
    AgendaManagement.getCityByState(stateID)
      .then((result: IGetCityListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.cityID,
          label: item.cityName,
        }));
        setOptionsCity(updatedOptions);
        setOptionsCityCopy(updatedOptions);
      })
      .catch(() => setOpenMessageError(true));
  };

  const getAdvisorsBySupervisors = (cityID: number) => {
    AgendaManagement.getAdvisorsBySupervisors(cityID)
      .then((result: IGetAdviserListDto[]) => {
        const filteredResult = result.filter(
          (item) => item.role?.trim().toLowerCase() !== "back office"
        );
        const updatedOptions = filteredResult.map((item) => ({
          value: item.userID,
          label: item.userName + " " + item.lastName,
        }));
        setOptionsAdviser(updatedOptions);
        setOptionsAdviserCopy(updatedOptions);
      })
      .catch(() => setOpenMessageError(true));
  };

  const getAppointmentsByUser = (userID: number, languageID: number) => {
    AgendaManagement.getAppointmentOccurrencesByUser(userID, languageID)
      .then((result: IGetAppointmentOccurrenceByUser[]) => {
        const safeResult = Array.isArray(result) ? result : [];
        if (safeResult.length > 0) {
          getTypeOfAppointmentListByRoleType();
        }
        setRawAppointments(safeResult);
        fillData(safeResult);
      })
      .catch(() => setOpenMessageError(true));
  };

  const handleActionRowConfig = (
    e: React.SyntheticEvent,
    option?: OptionInterface
  ) => {
    if (option) {
      const [action, idStr] = String(option.value).split(":");
      const appointmentId = Number(idStr);
      setAppointmentSelected(appointmentId);
      if (action === "edit") {
        const item = rawAppointments.find((x) => x.appointmentID === appointmentId);
        if (!item || !canOpenEditForAppointment(item)) {
          if (item && isRestrictionDueToCheckedIn(item)) {
            showCheckedInOccurrenceRestriction();
          } else {
            showPastOccurrenceRestriction();
          }
          return;
        }

        ChargeInfoForEdit(appointmentId);
        if (
          item?.appointmentTypeID === AppointmentTypeEnum.Permanent ||
          item?.appointmentTypeID === AppointmentTypeEnum.Route
        ) {
          setShowModalEditAgendaPermanent(true);
        } else if (
          item?.appointmentTypeID === AppointmentTypeEnum.Visit ||
          item?.appointmentTypeID === AppointmentTypeEnum.VisitAlt
        ) {
          setShowModalEditAgendaVisit(true);
        }
      } else if (action === "delete") {
        const item = rawAppointments.find((x) => x.appointmentID === appointmentId);
        if (!item || !canOpenEditForAppointment(item)) {
          if (item && isRestrictionDueToCheckedIn(item)) {
            showCheckedInOccurrenceRestriction();
          } else {
            showPastOccurrenceRestriction();
          }
          return;
        }
        setDeleteSeriesPayload({ appointmentID: appointmentId });
        setShowModalDeleteAgenda(true);
      }
    }
  };

  const ChargeInfoForEdit = (appointmentId: number, occurrenceId?: number) => {
    let item = rawAppointments.find((x) => x.appointmentID === appointmentId);

    if (item) {
      setTypeOfVisit([item.appointmentTypeID]);
      setTypeOfVisitId(item.appointmentTypeID);

      const isVisitType =
        item.appointmentTypeID === AppointmentTypeEnum.Visit ||
        item.appointmentTypeID === AppointmentTypeEnum.VisitAlt;

      // For Visit/VisitAlt: resolve the occurrence even when no explicit occurrenceId is given
      // (there is exactly one occurrence per Visit appointment — use it as the source of truth)
      let occurrence: IOccurrenceDetail | undefined;
      if (occurrenceId !== undefined) {
        occurrence = item.occurrences?.find((o) => o.appointmentOccurrenceID === occurrenceId);
      }

      const posCode     = occurrence?.posCode      ?? item.posCode;
      const hourIn      = occurrence?.assignHourIn  ?? item.assignHourIn;
      const hourOut     = occurrence?.assignHourOut ?? item.assignHourOut;
      const subRetailID = occurrence?.subRetailID   ?? item.subretailID;

      getSubretail();
      getPointOfsale(subRetailID);

      if (isVisitType) {
        // Dates must come from the occurrence, not the parent series
        const occurrenceDate = occurrence?.occurrenceDate ?? item.dateStart;
        setSubRetail([subRetailID]);
        setPointOfSale([posCode]);
        setStartTime(moment.utc(hourIn, "H:mm"));
        setEndTime(moment.utc(hourOut, "H:mm"));
        setStartDate(occurrenceDate);
        setEndDate(occurrenceDate);
        setVisitDate(occurrenceDate);
      } else {
        setSubRetail([subRetailID]);
        setPointOfSale([posCode]);
        setStartTime(moment.utc(hourIn, "H:mm"));
        setEndTime(moment.utc(hourOut, "H:mm"));
        setStartDate(item.dateStart);
        setEndDate(item.dateEnd);
        setVisitDate(item.dateStart);
        setCheckboxMonday(item.monday);
        setCheckboxTuesday(item.tuesday);
        setCheckboxWednesday(item.wednesday);
        setCheckboxThursday(item.thursday);
        setcheckboxFriday(item.friday);
        setCheckboxSaturday(item.saturday);
        setCheckboxSunday(item.sunday);
      }
    }
  };

  const FormatDate = (date: string) => {
    let timestamp = Date.parse(date);
    if (!isNaN(timestamp)) {
      let dateTemp = new Date(date);
      let year = dateTemp.getFullYear();
      let month = (dateTemp.getMonth() + 1).toString().padStart(2, "0");
      let day = dateTemp.getDate().toString().padStart(2, "0");

      return `${year}-${month}-${day}`;
    } else {
      return "";
    }
  };

  const fillData = (data: IGetAppointmentOccurrenceByUser[]) => {
    const pagedData: TableData[] = [];

    for (let i = 0; i < data.length; i++) {
      const agenda: IGetAppointmentOccurrenceByUser = data[i];
      let tableData: TableData = {};
      tableData = {
        appointmentId: agenda.appointmentID,
        subretail: agenda.subretailName,
        subretailId: agenda.subretailID,
        posCode: agenda.posCode,
        pos: agenda.pointOfSale,
        typeAppointment: agenda.appointmentType,
        typeAppointmentId: agenda.appointmentTypeID,
        startDate: FormatDate(agenda.dateStart),
        endDate: FormatDate(agenda.dateEnd),
        assignHourIn: agenda.assignHourIn,
        assignHourOut: agenda.assignHourOut,
        monday: agenda.monday,
        tuesday: agenda.tuesday,
        wednesday: agenda.wednesday,
        thursday: agenda.thursday,
        friday: agenda.friday,
        saturday: agenda.saturday,
        sunday: agenda.sunday,
        latitude: agenda.latitude,
        longitude: agenda.longitude,
        rowConfig: {
          action: (
            <ContextualMenu
              onClick={handleActionRowConfig}
              options={[
                {
                  value: `edit:${agenda.appointmentID}`,
                  label: t("header.edit"),
                  icon: <IconPencil />,
                },
                {
                  value: `delete:${agenda.appointmentID}`,
                  label: t("header.delete"),
                  icon: <IconTrash />,
                },
              ]}
              placement="leading"
            />
          ),
          disabled: false,
          noWrap: false,
          selected: false,
        },
      };
      pagedData.push(tableData);
    }
    setTableData(pagedData);
    setTableFilteredData(pagedData);
  };

  const fillDataTypeOfAppointment = (data: ITypeOfAppointmentDto[]) => {
    const typeOfAppointmentData: SelectOption[] = [];

    for (let i = 0; i < data.length; i++) {
      const typeOfAppointment: ITypeOfAppointmentDto = data[i];
      let selectTypeOfAppointmentData: SelectOption;
      if (typeOfAppointment.fieldID !== 0) {
        selectTypeOfAppointmentData = {
          value: typeOfAppointment.fieldID,
          label: typeOfAppointment.fieldValue,
        };
        typeOfAppointmentData.push(selectTypeOfAppointmentData);
      }
    }
    setTypeofAppointmentData(typeOfAppointmentData);
    setTypeofAppointmentDataCopy(typeOfAppointmentData);
  };

  const fillDataSubretail = (data: ISubretailDto[]) => {
    const subretailData: SelectOption[] = [];

    for (let i = 0; i < data.length; i++) {
      const subretail: ISubretailDto = data[i];
      let selectSubretailData: SelectOption;
      if (subretail.fieldID !== 0) {
        selectSubretailData = {
          value: subretail.fieldID,
          label: subretail.fieldValue,
        };
        subretailData.push(selectSubretailData);
      }
    }
    setSubretailData(subretailData);
    setSubretailDataCopy(subretailData);
  };

  const fillDataPointOfSale = (data: IPointOfSaleByListDto[]) => {
    const pointOfsaleData: SelectOption[] = [];

    for (let i = 0; i < data.length; i++) {
      const pointOfsale: IPointOfSaleByListDto = data[i];
      let selectePointOfSaleData: SelectOption;
      if (pointOfsale.fieldID) {
        selectePointOfSaleData = {
          value: pointOfsale.fieldID,
          label: pointOfsale.fieldValue,
        };
        pointOfsaleData.push(selectePointOfSaleData);
      }
    }
    setPointOfSaleData(pointOfsaleData);
    setPointOfSaleDataCopy(pointOfsaleData);
  };

  const ResetFormAgenda = () => {
    setTypeOfVisit([]);
    setTypeOfVisitId(NaN);
    setDisableTypeOfVisit(true);
    setSubRetail([]);
    setDisableSubretail(true);
    setPointOfSale([]);
    setDisablePointOfSale(true);
    setStartTime(null);
    setEndTime(null);
    setStartDate("");
    setEndDate("");
    setVisitDate("");
    setCheckboxMonday(false);
    setCheckboxTuesday(false);
    setCheckboxWednesday(false);
    setCheckboxThursday(false);
    setcheckboxFriday(false);
    setCheckboxSaturday(false);
    setCheckboxSunday(false);
    setErrorDatePicker(false);
    setErrorPos(false);
    setIsValidCoordinates(false);
    setEditSeriesOccurrenceDate(null);
    setStartTimeErrorReason(null);
    setEndTimeErrorReason(null);
  };

  const onClearAdvisorSelect = () => {
    setTableData([]);
    setTableFilteredData([]);
    setRawAppointments([]);
    setValueAdviser([]);
    setOpenAddAgendaDisable(true);
  };

  const onClearStateSelect = () => {
    setTableData([]);
    setTableFilteredData([]);
    setRawAppointments([]);
    setValueState([]);
    setValueCity([]);
    setValueAdviser([]);
    getAdvisorsBySupervisors(0);
    setIsStateValid(true);
    setDisableAdvisor(false);
  };

  const onClearCitySelect = () => {
    setTableData([]);
    setTableFilteredData([]);
    setRawAppointments([]);
    setValueCity([]);
    setValueAdviser([]);
    setOptionsAdviser([]);
  };

  const onChangeState = (selectedOption: SelectOption) => {
    setValueState([Number(selectedOption.value)]);
    getCityByState(Number(selectedOption.value));
    setOptionsAdviser([]);
    setValueCity([]);
    setValueAdviser([]);
    setDisableAdvisor(true);

    if (selectedOption) {
      setIsStateValid(false);
    }
  };

  const onChangeCity = (selectedOption: SelectOption) => {
    setValueCity([Number(selectedOption.value)]);
    getAdvisorsBySupervisors(Number(selectedOption.value));

    if (selectedOption) {
      setDisableAdvisor(false);
    }
  };

  const onChangeAdviser = (selectedOption: SelectOption) => {
    setValueAdviser([Number(selectedOption.value)]);
    if (selectedOption.value !== undefined) {
      setOpenAddAgendaDisable(false);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        UserID: Number(selectedOption.value),
      });
    }

    getAppointmentsByUser(Number(selectedOption.value), languageID.value);
  };

  const submitAddAgenda = () => {
    const isVisitCreate =
      formCreateAppoiment.AppointmentTypeID === AppointmentTypeEnum.Visit ||
      formCreateAppoiment.AppointmentTypeID === AppointmentTypeEnum.VisitAlt;
    const relevantCreateDate = isVisitCreate
      ? formCreateAppoiment.DateVisit
      : formCreateAppoiment.DateStart;
    if (
      relevantCreateDate &&
      moment(relevantCreateDate).isSame(moment(), 'day') &&
      startTime !== null &&
      moment(startTime).isBefore(moment(), 'minute')
    ) {
      setOpenMessageStartDateError(true);
      return;
    }

    AgendaManagement.createAppointmentOccurrence({ ...formCreateAppoiment, SilentExecution: false })
      .then((r) => {
        switch (r) {
          case 0: {
            setOpenMessageError(true);
            break;
          }
          case 1: {
            setShowModalAddAgenda(false);
            ResetFormAgenda();
            setOpenMessageCreatedAgenda(true);
            getAppointmentsByUser(valueAdviser[0], languageID.value);
            break;
          }
          case 2: {
            setOpenMessageExistingAgenda(true);
            break;
          }
          default: {
            setOpenMessageError(true);
          }
        }
      })
      .catch(() => setOpenMessageError(true));
  };

  const cancelAddAgenda = () => {
    setShowModalAddAgenda(false);
    setErrorPos(false);
    setIsValidCoordinates(false);
    ResetFormAgenda();
  };

  const getDayOfWeek = (dateString: string): string => {
    const date = new Date(dateString);
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return daysOfWeek[date.getDay()];
  };

  const showPastOccurrenceRestriction = () => {
    setOpenMessagePastOccurrenceRestricted(true);
  };

  const showCheckedInOccurrenceRestriction = () => {
    setOpenMessageCheckedInRestricted(true);
  };

  const isRestrictionDueToCheckedIn = (item: IGetAppointmentOccurrenceByUser): boolean => {
    if (!item.occurrences || item.occurrences.length === 0) return false;
    const today = new Date();
    const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    for (const occ of item.occurrences) {
      if (occ.isCheckIn === true && occ.occurrenceDate) {
        const occDate = parseLocalDate(occ.occurrenceDate);
        const occDay = new Date(occDate.getFullYear(), occDate.getMonth(), occDate.getDate());
        if (occDay.getTime() === todayDate.getTime()) {
          return true;
        }
      }
    }
    return false;
  };

  const buildOccurrenceOptions = (item: IGetAppointmentOccurrenceByUser): SelectOption[] => {
    // New data path — use pre-computed occurrences from the API
    if (item.occurrences && item.occurrences.length > 0) {
      return item.occurrences
        .filter((occ) => !!occ.occurrenceDate)
        .filter((occ) => !isPastAppointmentOccurrence(item, occ.occurrenceDate!))
        .filter((occ) => !hasCheckedInOccurrence(occ))
        .map((occ) => ({
          value: occ.appointmentOccurrenceID,
          label: moment(occ.occurrenceDate).format("ddd, ll"),
        }));
    }

    const start = parseLocalDate(item.dateStart);
    const end = parseLocalDate(item.dateEnd || item.dateStart);
    const current = new Date(start);
    const options: SelectOption[] = [];

    const weekdayFlags = [
      item.sunday,
      item.monday,
      item.tuesday,
      item.wednesday,
      item.thursday,
      item.friday,
      item.saturday,
    ];

    let remainingIterations = MAX_OCCURRENCE_SCAN_DAYS;
    while (current <= end && remainingIterations > 0) {
      const weekdayIndex = current.getDay();
      if (weekdayFlags[weekdayIndex]) {
        const value = moment(current).format("YYYY-MM-DD");
        options.push({
          value,
          label: moment(current).format("ddd, ll"),
        });
      }

      current.setDate(current.getDate() + 1);
      remainingIterations--;
    }

    return options;
  };

  const hasCheckedInOccurrence = (occ: IOccurrenceDetail | null | undefined): boolean =>
    occ?.isCheckIn === true;

  const canOpenEditForAppointment = (
    item: IGetAppointmentOccurrenceByUser,
    occurrenceDate?: Date | string
  ): boolean => {
    if (occurrenceDate) {
      const dateStr = String(occurrenceDate).split("T")[0];
      const occ = item.occurrences?.find((o) => o.occurrenceDate?.split("T")[0] === dateStr);
      if (hasCheckedInOccurrence(occ)) return false;
      return !isPastAppointmentOccurrence(item, occurrenceDate);
    }

    const isRecurringType =
      item.appointmentTypeID === AppointmentTypeEnum.Permanent ||
      item.appointmentTypeID === AppointmentTypeEnum.Route;

    if (!isRecurringType) {
      const occ = item.occurrences?.find(
        (o) => o.occurrenceDate?.split("T")[0] === item.dateStart.split("T")[0]
      );
      if (hasCheckedInOccurrence(occ)) return false;
      return !isPastAppointmentOccurrence(item, item.dateStart);
    }

    const occurrenceOptions = buildOccurrenceOptions(item);
    return occurrenceOptions.some(
      (option) => !isPastAppointmentOccurrence(item, String(option.value))
    );
  };

  const getEditableOccurrences = (
    item: IGetAppointmentOccurrenceByUser
  ): IOccurrenceDetail[] => {
    const now = new Date();
    if (!item.occurrences?.length) return [];

    return item.occurrences.filter((occ) => {
      if (!occ.occurrenceDate) return false;
      const occHourIn  = occ.assignHourIn  || item.assignHourIn;
      const occHourOut = occ.assignHourOut || item.assignHourOut;
      const probe = {
        dateStart:     item.dateStart,
        assignHourIn:  occHourIn,
        assignHourOut: occHourOut,
      };
      // TRUE = editable (end-time has not yet passed)
      return !isPastAppointmentOccurrence(probe, occ.occurrenceDate, now);
    });
  };

  
  const getEarliestEligibleSeriesDate = (
    item: IGetAppointmentOccurrenceByUser
  ): string | null => {
    const now = new Date();

    if (item.occurrences && item.occurrences.length > 0) {
      const sorted = [...item.occurrences]
        .filter((occ) => !!occ.occurrenceDate)
        .sort((a, b) => (a.occurrenceDate! < b.occurrenceDate! ? -1 : 1));

      for (const occ of sorted) {
        const occHourIn  = occ.assignHourIn  || item.assignHourIn;
        const occHourOut = occ.assignHourOut || item.assignHourOut;
        const probe = {
          dateStart:     item.dateStart,
          assignHourIn:  occHourIn,
          assignHourOut: occHourOut,
        };
        if (!isPastAppointmentOccurrence(probe, occ.occurrenceDate!, now)) {
          return occ.occurrenceDate!.split("T")[0];
        }
      }
      return null;
    }

    if (!item.dateStart) return null;
    const rangeStart     = parseLocalDate(item.dateStart);
    const rangeEnd       = parseLocalDate(item.dateEnd || item.dateStart);
    const todayMidnight  = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const cursor         = new Date(rangeStart > todayMidnight ? rangeStart : todayMidnight);
    const dayFlags       = [
      item.sunday, item.monday, item.tuesday, item.wednesday,
      item.thursday, item.friday, item.saturday,
    ];
    let remaining = MAX_OCCURRENCE_SCAN_DAYS;

    while (cursor <= rangeEnd && remaining > 0) {
      if (dayFlags[cursor.getDay()]) {
        if (!isPastAppointmentOccurrence(item, new Date(cursor), now)) {
          const y = cursor.getFullYear();
          const m = String(cursor.getMonth() + 1).padStart(2, "0");
          const d = String(cursor.getDate()).padStart(2, "0");
          return `${y}-${m}-${d}`;
        }
      }
      cursor.setDate(cursor.getDate() + 1);
      remaining--;
    }

    return null;
  };

  const performUpdateAppointment = (appointmentUpdateIn: IUpdateAppoiment) => {
    AgendaManagement.postUpdateAppointment(appointmentUpdateIn)
      .then((r) => {
        switch (r) {
          case 0: {
            setOpenMessageError(true);
            break;
          }
          case 1: {
            setShowModalEditAgendaPermanent(false);
            setShowModalEditAgendaVisit(false);
            setAppointmentSelected(NaN);
            setOpenMessageUpdateAgenda(true);
            getAppointmentsByUser(valueAdviser[0], languageID.value);
            break;
          }
          case 2: {
            setOpenMessageExistingAgenda(true);
            break;
          }
          case 3: {
            setOpenMessageExpiredAgenda(true);
            break;
          }
          default: {
            setOpenMessageError(true);
          }
        }
      })
      .catch(() => setOpenMessageError(true))
      .finally(() => {
        ResetFormAgenda();
      });
  };

  const submitEditAgenda = () => {
    const item = tableData.find((x) => x.appointmentId === appointmentSelected);
    const selectedItem = rawAppointments.find(
      (x) => x.appointmentID === appointmentSelected
    );

    const dayOfWeek = getDayOfWeek(String(visitDate));

    const isVisitAppointment =
      item?.typeAppointmentId === AppointmentTypeEnum.Visit ||
      item?.typeAppointmentId === AppointmentTypeEnum.VisitAlt;

    const isRecurringType =
      !isVisitAppointment &&
      (item?.typeAppointmentId === AppointmentTypeEnum.Permanent ||
        item?.typeAppointmentId === AppointmentTypeEnum.Route);

    if (isVisitAppointment && selectedItem) {
      if (!canOpenEditForAppointment(selectedItem, visitDate)) {
        setShowModalEditAgendaVisit(false);
        showPastOccurrenceRestriction();
        return;
      }
    }

    // For recurring types, validate time against the selected occurrence date (not the series
    // start date), so August 1 does not incorrectly trigger a past-time error on August 7.
    const relevantEditDate = isVisitAppointment
      ? String(visitDate)
      : isRecurringType && editSeriesOccurrenceDate
        ? editSeriesOccurrenceDate
        : String(startDate);
    if (
      relevantEditDate &&
      moment(relevantEditDate).isSame(moment(), 'day') &&
      startTime !== null &&
      moment(startTime).isBefore(moment(), 'minute')
    ) {
      setOpenMessageStartDateError(true);
      return;
    }

    // effectiveStartDate uses the form value (series start date or user-edited date).
    // It is NOT replaced with the earliest editable occurrence — the series dates are
    // preserved in the payload exactly as shown in the form.
    let effectiveStartDate = FormatDate(String(startDate));
    if (isRecurringType && selectedItem) {
      if (selectedItem.occurrences && selectedItem.occurrences.length > 0) {
        // Validity gate: at least one editable occurrence must exist
        const editableOccurrences = getEditableOccurrences(selectedItem);
        if (editableOccurrences.length === 0) {
          setShowModalEditAgendaPermanent(false);
          showPastOccurrenceRestriction();
          return;
        }
      } else {
        // Legacy-path: no pre-computed occurrences — scan day-flags for validity
        const eligibleStart = getEarliestEligibleSeriesDate(selectedItem);
        if (!eligibleStart) {
          setShowModalEditAgendaPermanent(false);
          showPastOccurrenceRestriction();
          return;
        }
      }
    }

    const toHourString = (value: string | moment.Moment | null): string => {
      if (moment.isMoment(value)) return value.format("H:mm");
      if (typeof value === "string") return moment.utc(value, "H:mm").format("H:mm");
      return "";
    };

    const appointmentUpdateIn: IUpdateAppoiment = {
      AppointmentID: appointmentSelected,
      PosCode: String(pointOfSale[0] ?? ""),
      DateStart: isVisitAppointment
        ? FormatDate(String(visitDate))
        : effectiveStartDate,
      DateEnd: isVisitAppointment
        ? FormatDate(String(visitDate))
        : FormatDate(String(endDate)),
      DateVisit: isVisitAppointment
        ? FormatDate(String(visitDate))
        : effectiveStartDate,
      AssignHourIn: toHourString(startTime),
      AssignHourOut: toHourString(endTime),
      Monday:    isVisitAppointment ? dayOfWeek === "Monday"    : checkboxMonday,
      Tuesday:   isVisitAppointment ? dayOfWeek === "Tuesday"   : checkboxTuesday,
      Wednesday: isVisitAppointment ? dayOfWeek === "Wednesday" : checkboxWednesday,
      Thursday:  isVisitAppointment ? dayOfWeek === "Thursday"  : checkboxThursday,
      Friday:    isVisitAppointment ? dayOfWeek === "Friday"    : checkboxFriday,
      Saturday:  isVisitAppointment ? dayOfWeek === "Saturday"  : checkboxSaturday,
      Sunday:    isVisitAppointment ? dayOfWeek === "Sunday"    : checkboxSunday,
      UserID: valueAdviser[0] ?? 0,
    };

    if (isRecurringType) {
      const formattedEnd = FormatDate(String(endDate));
      if (effectiveStartDate && formattedEnd && formattedEnd < effectiveStartDate) {
        setErrorDatePicker(true);
        return;
      }
      performUpdateAppointment(appointmentUpdateIn);
      return;
    }

    // ── Visit / non-recurring: original date-change validation ────────────
    if (!isVisitAppointment) {
      const formattedStart = FormatDate(String(startDate));
      const formattedEnd = FormatDate(String(endDate));
      if (formattedStart && formattedEnd && formattedEnd < formattedStart) {
        setErrorDatePicker(true);
        return;
      }
    }

    const today = new Date();
    if (item?.startDate !== FormatDate(String(startDate))) {
      if (item?.startDate <= FormatDate(String(today))) {
        setErrorDatePicker(true);
        setOpenMessageStartDateError(true);
      } else {
        performUpdateAppointment(appointmentUpdateIn);
      }
    } else {
      performUpdateAppointment(appointmentUpdateIn);
    }
  };

  const submitEditOccurrences = async () => {
    if (selectedOccurrenceDates.length === 0) {
      setOpenMessageError(true);
      return;
    }

    if (!subRetail[0] || !pointOfSale[0] || !startTime || !endTime) {
      setOpenMessageError(true);
      return;
    }

    const selectedItem = rawAppointments.find(
      (x) => x.appointmentID === appointmentSelected
    );
    if (!selectedItem) {
      setOpenMessageError(true);
      return;
    }

    const hasPastDate = selectedOccurrenceDates.some((val) => {
      if (selectedItem.occurrences && selectedItem.occurrences.length > 0) {
        // val is an occurrenceID — look up its date for the past-date check
        const occ = selectedItem.occurrences.find(
          (o) => String(o.appointmentOccurrenceID) === val
        );
        return occ ? isPastAppointmentOccurrence(selectedItem, occ.occurrenceDate ?? undefined) : false;
      }
      return isPastAppointmentOccurrence(selectedItem, val);
    });

    if (hasPastDate) {
      setShowModalEditOccurrences(false);
      showPastOccurrenceRestriction();
      return;
    }

    const hasTodayWithPastTime =
      startTime !== null &&
      moment(startTime).isBefore(moment(), 'minute') &&
      selectedOccurrenceDates.some((val) => {
        let occDate: string | undefined;
        if (selectedItem.occurrences && selectedItem.occurrences.length > 0) {
          const occ = selectedItem.occurrences.find(
            (o) => String(o.appointmentOccurrenceID) === val
          );
          occDate = occ?.occurrenceDate?.split("T")[0];
        } else {
          occDate = val;
        }
        return occDate ? moment(occDate).isSame(moment(), 'day') : false;
      });
    if (hasTodayWithPastTime) {
      setOpenMessageStartDateError(true);
      return;
    }

    const newAssignHourIn  = `${moment(startTime).format("HH:mm")}:00`;
    const newAssignHourOut = `${moment(endTime).format("HH:mm")}:00`;
    const newPosCode       = String(pointOfSale[0]);
    const newSubRetailID   = Number(subRetail[0]);
    const newSubRetailName = subretailData.find((s) => Number(s.value) === newSubRetailID)?.label ?? "";
    const userID           = valueAdviser[0] ?? 0;

    try {
      if (selectedItem.occurrences && selectedItem.occurrences.length > 0) {
        // New path — resolve all selected occurrences from the data model
        const selectedOccs = selectedItem.occurrences.filter((o) =>
          selectedOccurrenceDates.includes(String(o.appointmentOccurrenceID))
        );
        if (selectedOccs.length === 0) {
          setOpenMessageError(true);
          return;
        }
        const payload: IUpdateSingleOccurrenceDto = {
          OccurrenceIDs:    selectedOccs.map((o) => o.appointmentOccurrenceID),
          AppointmentID:    appointmentSelected,
          UserID:           userID,
          NewPosCode:       newPosCode,
          NewAssignHourIn:  newAssignHourIn,
          NewAssignHourOut: newAssignHourOut,
          NewSubRetailID:   newSubRetailID,
          NewSubRetailName: newSubRetailName,
        };
        const result = await AgendaManagement.updateSingleAppointmentOccurrence(payload);
        if (result !== 1) {
          setOpenMessageError(true);
          return;
        }
      } else {
        const updatePayload: IUpdateAppointmentOccurrencesDto = {
          AppointmentID:    appointmentSelected,
          UserID:           userID,
          DatesCsv:         selectedOccurrenceDates.join(","),
          NewPosCode:       newPosCode,
          NewAssignHourIn:  newAssignHourIn,
          NewAssignHourOut: newAssignHourOut,
          NewSubRetailID:   newSubRetailID,
          NewSubRetailName: newSubRetailName,
        };
        const response = await AgendaManagement.updateAppointmentOccurrences(updatePayload);
        if (response !== 1) {
          setOpenMessageError(true);
          return;
        }
      }

      setShowModalEditOccurrences(false);
      setOpenMessageUpdateAgenda(true);
      setAppointmentSelected(NaN);
      setSelectedOccurrenceDates([]);
      setOccurrenceOptions([]);
      setCurrentEditOccurrenceValue('');
      setIsOccurrenceTodayForEdit(false);
      setOccStartTimeErrorReason(null);
      setOccEndTimeErrorReason(null);
      getAppointmentsByUser(valueAdviser[0], languageID.value);
      ResetFormAgenda();
    } catch {
      setOpenMessageError(true);
    }
  };

  const cancelEditAgendaPermanent = () => {
    setShowModalEditAgendaPermanent(false);
    setErrorDatePicker(false);
    setIsValidCoordinates(false);
    setAppointmentSelected(NaN);
    ResetFormAgenda();
  };

  const cancelEditAgendaVisit = () => {
    setShowModalEditAgendaVisit(false);
    setIsValidCoordinates(false);
    setAppointmentSelected(NaN);
    ResetFormAgenda();
  };

  const cancelEditOccurrences = () => {
    setShowModalEditOccurrences(false);
    setAppointmentSelected(NaN);
    setSelectedOccurrenceDates([]);
    setOccurrenceOptions([]);
    setCurrentEditOccurrenceValue('');
    setIsOccurrenceTodayForEdit(false);
    setOccStartTimeErrorReason(null);
    setOccEndTimeErrorReason(null);
    setIsValidCoordinates(false);
    ResetFormAgenda();
  };

  const handleChangeTypeOfVisit = (value: SelectValue) => {
    setTypeOfVisit([value]);
    setTypeOfVisitId(Number(value));
    setDisableTypeOfVisit(true);
    getSubretail();
    setFormCreateAppoiment({
      ...formCreateAppoiment,
      AppointmentTypeID: Number(value),
    });
  };

  const onClearTypeOfVisit = () => {
    ResetFormAgenda();
    setDisablePointOfSale(true);
  };

  const handleChangeSubRetail = (value: SelectValue) => {
    setSubRetail([value]);
    getPointOfsale(parseInt(value.toString()));
  };

  const handleChangePointOfSale = (value: SelectValue) => {
    setPointOfSale([value]);
    setFormCreateAppoiment({
      ...formCreateAppoiment,
      PosCode: value.toString(),
    });
  };

  const onClearSubRetail = () => {
    setSubRetail([]);
    setPointOfSale([]);
    setDisablePointOfSale(true);
  };

  const handleChangeSubRetailList = (value: SelectValue) => {
    const valueCopy = [...subRetail];
    const isOptionSelected = valueCopy.includes(value);

    if (isOptionSelected) {
      const index = valueCopy.indexOf(value);
      valueCopy.splice(index, 1);
    } else {
      valueCopy.push(value);
    }
    setSubRetail(valueCopy);

    getPointOfsaleByList(String(valueCopy));
  };

  const handleChangePointOfSaleList = (value: SelectValue) => {
    const valueCopy = [...pointOfSale];

    const isOptionSelected = valueCopy.includes(value);
    if (isOptionSelected) {
      const index = valueCopy.indexOf(value);
      valueCopy.splice(index, 1);
    } else {
      valueCopy.push(value);
    }
    setFormCreateAppoiment({
      ...formCreateAppoiment,
      PosCode: valueCopy.join(", "),
    });
    setPointOfSale(valueCopy);
  };

  const deleteAgenda = () => {
    if (!deleteSeriesPayload) return;

    const appointment = rawAppointments.find(
      (a) => a.appointmentID === deleteSeriesPayload.appointmentID
    );

    if (appointment && appointment.occurrences && appointment.occurrences.length > 0) {
      const futureOccurrenceIDs = buildSelectableOccurrences(appointment)
        .map((o) => o.occurrenceID)
        .filter((id): id is number => id !== null);

      if (futureOccurrenceIDs.length === 0) {
        // All occurrences are in the past — nothing eligible to delete.
        setShowModalDeleteAgenda(false);
        setOpenMessageExpiredAgenda(true);
        return;
      }
    }

    AgendaManagement.deleteAppointment(deleteSeriesPayload.appointmentID)
      .then((r) => {
        switch (r) {
          case 0: {
            setShowModalDeleteAgenda(false);
            setDeleteSeriesPayload(null);
            setOpenMessageError(true);
            getAppointmentsByUser(valueAdviser[0], languageID.value);
            break;
          }
          case 1: {
            setTableData([]);
            setTableFilteredData([]);
            setShowModalDeleteAgenda(false);
            setAppointmentSelected(NaN);
            setDeleteSeriesPayload(null);
            setOpenMessageDeleteAgenda(true);
            getAppointmentsByUser(valueAdviser[0], languageID.value);
            break;
          }
          case 2: {
            setOpenMessageToDeleteAgendaWithCheckIn(true);
            break;
          }
          case 3: {
            setOpenMessageExpiredAgenda(true);
            break;
          }
          default: {
            setOpenMessageError(true);
          }
        }
      })
      .catch(() => setOpenMessageError(true));
  };

  const cancelDeleteAgenda = () => {
    setShowModalDeleteAgenda(false);
  };

  const openModalAddAgenda = () => {
    setFormCreateAppoiment({
      ...formCreateAppoiment,
      PosCode: "",
      DateStart: "",
      DateEnd: "",
      DateVisit: "",
      AssignHourIn: "",
      AssignHourOut: "",
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
      AppointmentTypeID: 0,
    });
    setShowModalAddAgenda(true);
    getTypeOfAppointmentListByRoleType();
  };

  const handleChangeStartDate = (date: DateRange) => {
    if (date.startDate === undefined && date.endDate === undefined) {
      setVisitDate(String(date));
      const dayOfWeek = getDayOfWeek(String(date));
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        DateVisit: FormatDate(String(date)),
        DateStart: FormatDate(String(date)),
        DateEnd: FormatDate(String(date)),
        Monday: dayOfWeek === "Monday",
        Tuesday: dayOfWeek === "Tuesday",
        Wednesday: dayOfWeek === "Wednesday",
        Thursday: dayOfWeek === "Thursday",
        Friday: dayOfWeek === "Friday",
        Saturday: dayOfWeek === "Saturday",
        Sunday: dayOfWeek === "Sunday",
      });
    } else {
      if (date.startDate != null) setStartDate(String(date.startDate));
      setEndDate(date.endDate != null ? String(date.endDate) : "");

      setFormCreateAppoiment({
        ...formCreateAppoiment,
        DateVisit: FormatDate(String(date.startDate)),
        DateStart: FormatDate(String(date.startDate)),
        DateEnd: FormatDate(String(date.endDate)),
      });
    }
  };

  const handleChangeVisitDate = (date: DateRange) => {
    if (!date) {
      setVisitDate("");
      return;
    }
    // mirror handleChangeStartDate: single-date pickers pass the moment directly
    if (date.startDate === undefined && date.endDate === undefined) {
      setVisitDate(String(date));
    } else if (date.startDate != null) {
      setVisitDate(String(date.startDate));
    } else {
      // startDate is null — user cleared the DatePicker via DateRange callback
      setVisitDate("");
    }
  };

  const handleStartTimeChange = (newStartTime: any) => {
    setStartTime(newStartTime);
    if (
      endTime &&
      newStartTime &&
      moment(newStartTime).isAfter(moment(endTime))
    ) {
      setEndTime(newStartTime);
    }
    setFormCreateAppoiment({
      ...formCreateAppoiment,
      AssignHourIn: moment(String(newStartTime)).format("H:mm"),
    });
  };

  const handleEndTimeChange = (newEndTime: any) => {
    if (
      startTime &&
      newEndTime &&
      moment(newEndTime).isBefore(moment(startTime))
    ) {
      return;
    }
    setEndTime(newEndTime);
    setFormCreateAppoiment({
      ...formCreateAppoiment,
      AssignHourOut: moment(String(newEndTime)).format("H:mm"),
    });
  };

  const onChangeCheckboxCreateAgenda = (day: number) => {
    if (day === 1) {
      setCheckboxMonday(!checkboxMonday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Monday: !checkboxMonday,
      });
    } else if (day === 2) {
      setCheckboxTuesday(!checkboxTuesday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Tuesday: !checkboxTuesday,
      });
    } else if (day === 3) {
      setCheckboxWednesday(!checkboxWednesday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Wednesday: !checkboxWednesday,
      });
    } else if (day === 4) {
      setCheckboxThursday(!checkboxThursday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Thursday: !checkboxThursday,
      });
    } else if (day === 5) {
      setcheckboxFriday(!checkboxFriday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Friday: !checkboxFriday,
      });
    } else if (day === 6) {
      setCheckboxSaturday(!checkboxSaturday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Saturday: !checkboxSaturday,
      });
    } else if (day === 7) {
      setCheckboxSunday(!checkboxSunday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Sunday: !checkboxSunday,
      });
    }
  };

  // ---- Calendar recurrence action handlers ----
  const handleEditSeries = (event: ICalendarEvent) => {
    const appointmentID = event.resource.appointmentID;
    const occurrenceDate = moment(event.start).format("YYYY-MM-DD");
    const item = rawAppointments.find((x) => x.appointmentID === appointmentID);
    const isVisitType = [AppointmentTypeEnum.Visit, AppointmentTypeEnum.VisitAlt].includes(event.resource.appointmentTypeID);
    const occurenceId = event?.occurrenceID;
    if (!item || !canOpenEditForAppointment(item, occurrenceDate)) {
      showPastOccurrenceRestriction();
      return;
    }

    setAppointmentSelected(appointmentID);
    setEditSeriesOccurrenceDate(occurrenceDate);
    isVisitType ? ChargeInfoForEdit(appointmentID, occurenceId ?? 0) : ChargeInfoForEdit(appointmentID);
    if (
      item?.appointmentTypeID === AppointmentTypeEnum.Visit ||
      item?.appointmentTypeID === AppointmentTypeEnum.VisitAlt
    ) {
      setShowModalEditAgendaVisit(true);
    } else {
      setShowModalEditAgendaPermanent(true);
    }
  };

  const handleEditOccurrences = (event: ICalendarEvent) => {
    const appointmentID = event.resource.appointmentID;
    const occurrenceDate = moment(event.start).format("YYYY-MM-DD");
    const item = rawAppointments.find((x) => x.appointmentID === appointmentID);

    if (
      !item ||
      (item.appointmentTypeID !== AppointmentTypeEnum.Permanent &&
        item.appointmentTypeID !== AppointmentTypeEnum.Route &&
        item.appointmentTypeID !== AppointmentTypeEnum.Visit &&
        item.appointmentTypeID !== AppointmentTypeEnum.VisitAlt)
    ) {
      return;
    }

    if (!canOpenEditForAppointment(item, occurrenceDate)) {
      showPastOccurrenceRestriction();
      return;
    }

    setAppointmentSelected(appointmentID);
    const occurrenceID = event.occurrenceID !== null ? event.occurrenceID : undefined;
    ChargeInfoForEdit(appointmentID, occurrenceID);
    setOccurrenceOptions(
      buildOccurrenceOptions(item).filter(
        (option) => !isPastAppointmentOccurrence(item, String(option.value))
      )
    );

    const preSelected = event.occurrenceID !== null
      ? [String(event.occurrenceID)]
      : [occurrenceDate];
    setSelectedOccurrenceDates(preSelected);
    setCurrentEditOccurrenceValue(preSelected[0]);
    setIsOccurrenceTodayForEdit(moment(occurrenceDate).isSame(moment(), 'day'));

    setShowModalEditOccurrences(true);
  };

  const handleDeleteSeries = (event: ICalendarEvent) => {
    const appointmentID = event.resource.appointmentID;
    setAppointmentSelected(appointmentID);
    setDeleteSeriesPayload({ appointmentID });
    setShowModalDeleteAgenda(true);
  };

  const handleDeleteOccurrence = (event: ICalendarEvent, mode: DeleteOccurrenceMode) => {
    const appointmentID = event.resource.appointmentID;
    setAppointmentSelected(appointmentID);
    setSelectedDeleteEvent(event);
    setDeleteOccurrenceMode(mode);
    setShowDeleteOccurrenceModal(true);
  };

  const handleOccurrencePayloadReady = async (payload: IDeleteOccurrencePayload) => {
    setShowDeleteOccurrenceModal(false);

    if (payload.occurrenceIDs.length === 0) {
      setOpenMessageError(true);
      return;
    }

    try {
      const response = await AgendaManagement.deleteAppointmentOccurrences({
        occurrenceIDs: payload.occurrenceIDs,
        appointmentID: payload.appointmentID,
        userId: valueAdviser[0] ?? 0,
      });
      if (response.deletedCount > 0) {
        setTableData([]);
        setTableFilteredData([]);
        setSelectedDeleteEvent(null);
        setDeleteOccurrenceMode(null);
        setOpenMessageDeleteAgenda(true);
        getAppointmentsByUser(valueAdviser[0], languageID.value);
      } else {
        setSelectedDeleteEvent(null);
        setDeleteOccurrenceMode(null);
        setOpenMessageError(true);
      }
    } catch {
      setSelectedDeleteEvent(null);
      setDeleteOccurrenceMode(null);
      setOpenMessageError(true);
    }
  };

  const handleCloseDeleteOccurrenceModal = () => {
    setShowDeleteOccurrenceModal(false);
    setSelectedDeleteEvent(null);
    setDeleteOccurrenceMode(null);
  };

  const timesAreEqual =
    isTimeValid(startTime) &&
    isTimeValid(endTime) &&
    moment(endTime).isSame(moment(startTime), 'minute');

  let endTimeErrorMessage = t("header.endTimeInvalidError");
  if (timesAreEqual) {
    endTimeErrorMessage = t("header.startEndTimeSameError");
  } else if (occEndTimeErrorReason === 'minTime') {
    endTimeErrorMessage = t("header.endTimeBeforeStartError");
  }

  const disableConfirmEdit =
    !subRetail[0] ||
    !pointOfSale[0] ||
    !isTimeValid(startTime) ||
    !isTimeValid(endTime) ||
    moment(endTime).isSameOrBefore(moment(startTime), 'minute') ||
    !!occStartTimeErrorReason ||
    !!occEndTimeErrorReason ||
    selectedOccurrenceDates.length === 0;

  return (
    <div className="generalAgendaDiv">
      <div className="topElements">
        <div className="divTitle">
          <h4 className="title">{t("header.schedulingAgendas")}</h4>
          <div className="divTittleSelects">
            <Select
              className="selectGeneralAgenda"
              options={optionsState}
              id="selectState"
              label={t("header.state")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeState}
              value={valueState}
              onClear={onClearStateSelect}
              onSearch={(query: string) =>
                handleSearch(query, optionsStateCopy, setOptionsState)
              }
              searchDelay={500}
              showSearch={true}
            />
            <Select
              className="selectGeneralAgenda"
              options={optionsCity}
              id="selectCity"
              label={t("header.city")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeCity}
              value={valueCity}
              disabled={isStateValid}
              onClear={onClearCitySelect}
              onSearch={(query: string) =>
                handleSearch(query, optionsCityCopy, setOptionsCity)
              }
              searchDelay={500}
              showSearch={true}
            />
            <Select
              className="selectGeneralAgenda"
              options={optionsAdviser}
              id="selectAdviser"
              label={t("header.adviser")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeAdviser}
              value={valueAdviser}
              disabled={disableAdvisor}
              onClear={onClearAdvisorSelect}
              onSearch={(query: string) =>
                handleSearch(query, optionsAdviserCopy, setOptionsAdviser)
              }
              searchDelay={500}
              showSearch={true}
              required={true}
            />

            <Button
              className="buttonAddAgenda buttonAddAgendaRight"
              leadingIcon={<IconDocumentCopy />}
              disabled={openAddAgendaDisable}
              onClick={openModalAddAgenda}
            >
              {t("header.addAgenda")}
            </Button>
            <Button
              className="buttonAddAgenda"
              disabled={openAddAgendaDisable}
              onClick={() => setShowModalWeeklyAgenda(true)}
              appearance="secondary"
            >
              {t("header.weeklyAgenda")}
            </Button>
          </div>
        </div>
      </div>

      {valueAdviser.length > 0 && (
        <AgendaCalendar
          appointments={rawAppointments}
          onEditSeries={handleEditSeries}
          onEditOccurrences={handleEditOccurrences}
          onDeleteSeries={handleDeleteSeries}
          onDeleteOccurrence={handleDeleteOccurrence}
          onPastOccurrenceRestricted={showPastOccurrenceRestriction}
          onCheckedInOccurrenceRestricted={showCheckedInOccurrenceRestriction}
        />
      )}

      {/* //Modal add agenda */}
      <div className="modalRelativeContainer">
        <Modal
          className="modalAddAgenda"
          closeButton={true}
          align="center"
          id="modalAddAgenda"
          show={showModalAddAgenda}
          onClose={cancelAddAgenda}
          footer={
            <ButtonGroup className="createAgendaButtongrouop">
              <Button
                disabled={addAgendaButtonDisable}
                onClick={submitAddAgenda}
              >
                {t("header.submit")}
              </Button>
              <Button onClick={cancelAddAgenda} appearance="secondary">
                {t("header.cancel")}
              </Button>
            </ButtonGroup>
          }
          title={t("header.addAgenda")}
        >
          <div className="createAgenda">
            <Select
              className="createAgendaSelect"
              label={t("header.typeOfVisit")}
              onChange={(e) => handleChangeTypeOfVisit(e.value)}
              options={typeofAppointmentData}
              value={typeOfVisit}
              onClear={() => onClearTypeOfVisit()}
              disabled={disableTypeOfVisit}
              onSearch={(query: string) =>
                handleSearch(
                  query,
                  typeofAppointmentDataCopy,
                  setTypeofAppointmentData
                )
              }
              searchDelay={500}
              showSearch={true}
            />

            <AgendaCreationBlock
              typeOfVisitID={typeOfVisitId}
              labelSubretail={t("header.subRetail")}
              handleChangeSubRetail={handleChangeSubRetail}
              subretailData={subretailData}
              subRetail={subRetail}
              onClearSubRetail={onClearSubRetail}
              disableSubretail={disableSubretail}
              labelPointOfSale={t("header.pointOfSale")}
              handleChangePointOfSale={handleChangePointOfSale}
              pointOfSaleData={pointOfSaleData}
              pointOfSale={pointOfSale}
              setPointOfSale={setPointOfSale}
              disablePointOfSale={disablePointOfSale}
              errorPos={errorPos}
              endDate={endDate}
              handleChangeStartDate={handleChangeStartDate}
              startDate={startDate}
              errorDatePicker={errorDatePicker}
              theme={theme}
              labelStartTime={t("header.startTime")}
              startTime={startTime}
              handleChangeStartTime={handleStartTimeChange}
              labelEndTime={t("header.endTime")}
              endTime={endTime}
              labelStardDate={t("header.stardDate")}
              labelEndDate={t("header.endDate")}
              handleChangeEndTime={handleEndTimeChange}
              labelMonday={t("header.monday")}
              checkboxMonday={checkboxMonday}
              onChangeCheckboxCreateAgenda={onChangeCheckboxCreateAgenda}
              labelTuesday={t("header.tuesday")}
              checkboxTuesday={checkboxTuesday}
              labelWednesday={t("header.wednesday")}
              checkboxWednesday={checkboxWednesday}
              labelThursday={t("header.thursday")}
              checkboxThursday={checkboxThursday}
              labelFriday={t("header.friday")}
              checkboxFriday={checkboxFriday}
              labelSaturday={t("header.saturday")}
              checkboxSaturday={checkboxSaturday}
              labelSunday={t("header.sunday")}
              checkboxSunday={checkboxSunday}
              labelVisitDate={t("header.visitDate")}
              visitDate={visitDate}
              handleChangePointOfSaleList={handleChangePointOfSaleList}
              handleChangeSubRetailList={handleChangeSubRetailList}
              subretailDataCopy={subretailDataCopy}
              setSubretailData={setSubretailData}
              pointOfSaleDataCopy={pointOfSaleDataCopy}
              setPointOfSaleData={setPointOfSaleData}
              startTimeErrorReason={startTimeErrorReason}
              setStartTimeErrorReason={setStartTimeErrorReason}
              endTimeErrorReason={endTimeErrorReason}
              setEndTimeErrorReason={setEndTimeErrorReason}
            />
          </div>
        </Modal>
      </div>

      {/* Modal delete agenda */}
      <div className="modalRelativeContainer">
        <Modal
          align="center"
          id="modalDeleteAgenda"
          show={showModalDeleteAgenda}
          onClose={() => setShowModalDeleteAgenda(false)}
          footer={
            <ButtonGroup className="deleteAgendaButtongrouop">
              <Button onClick={deleteAgenda}>{t("header.yes")}</Button>
              <Button onClick={cancelDeleteAgenda} appearance="secondary">
                {t("header.cancel")}
              </Button>
            </ButtonGroup>
          }
          title={t("modal.titleDeleteAgenda")}
        >
          <IconTrash size={150} />
          <p>{t("modal.questionDeleteAgenda")}</p>
        </Modal>
      </div>

      {/* Modal Delete Occurrences (by range / selected dates / only this date) */}
      <DeleteOccurrenceModal
        show={showDeleteOccurrenceModal}
        mode={deleteOccurrenceMode ?? "onlyThisDate"}
        event={selectedDeleteEvent}
        agenda={
          selectedDeleteEvent
            ? rawAppointments.find(
                (a) => a.appointmentID === selectedDeleteEvent.resource.appointmentID
              ) ?? null
            : null
        }
        onClose={handleCloseDeleteOccurrenceModal}
        onPreparePayload={handleOccurrencePayloadReady}
      />
      <div className="modalRelativeContainer">
        <AgendaEditingBLock
          showModalEditAgendaPermanent={showModalEditAgendaPermanent}
          cancelEditAgendaPermanent={cancelEditAgendaPermanent}
          editAgendaButtonDisable={editAgendaButtonDisable}
          submitEditAgenda={submitEditAgenda}
          handleChangeTypeOfVisit={handleChangeTypeOfVisit}
          typeofAppointmentData={typeofAppointmentData}
          typeOfVisit={typeOfVisit}
          onClearTypeOfVisit={onClearTypeOfVisit}
          handleChangeSubRetail={handleChangeSubRetail}
          subretailData={subretailData}
          subRetail={subRetail}
          onClearSubRetail={onClearSubRetail}
          setPointOfSale={setPointOfSale}
          pointOfSaleData={pointOfSaleData}
          pointOfSale={pointOfSale}
          errorPos={errorPos}
          endDate={endDate}
          handleChangeStartDate={handleChangeStartDate}
          startDate={startDate}
          errorDatePicker={errorDatePicker}
          startTime={startTime}
          setStartTime={setStartTime}
          endTime={endTime}
          setEndTime={setEndTime}
          checkboxMonday={checkboxMonday}
          setCheckboxMonday={setCheckboxMonday}
          checkboxTuesday={checkboxTuesday}
          setCheckboxTuesday={setCheckboxTuesday}
          checkboxWednesday={checkboxWednesday}
          setCheckboxWednesday={setCheckboxWednesday}
          checkboxThursday={checkboxThursday}
          setCheckboxThursday={setCheckboxThursday}
          checkboxFriday={checkboxFriday}
          setcheckboxFriday={setcheckboxFriday}
          checkboxSaturday={checkboxSaturday}
          setCheckboxSaturday={setCheckboxSaturday}
          checkboxSunday={checkboxSunday}
          setCheckboxSunday={setCheckboxSunday}
          showModalEditAgendaVisit={showModalEditAgendaVisit}
          cancelEditAgendaVisit={cancelEditAgendaVisit}
          handleChangeVisitDate={handleChangeVisitDate}
          visitDate={visitDate}
          startTimeErrorReason={startTimeErrorReason}
          setStartTimeErrorReason={setStartTimeErrorReason}
          endTimeErrorReason={endTimeErrorReason}
          setEndTimeErrorReason={setEndTimeErrorReason}
          editOccurrenceRef={editSeriesOccurrenceDate}
        />
      </div>

      {/* Modal Edit occurrences */}
      <div className="modalRelativeContainer">
        <Modal
          closeButton={true}
          align="center"
          id="modalEditOccurrences"
          show={showModalEditOccurrences}
          onClose={cancelEditOccurrences}
          footer={
            <ButtonGroup className="createAgendaButtongrouop">
              <Button disabled={disableConfirmEdit}
                onClick={submitEditOccurrences}>
                {t("header.submitEdit")}
              </Button>
              <Button onClick={cancelEditOccurrences} appearance="secondary">
                {t("header.cancel")}
              </Button>
            </ButtonGroup>
          }
          title={t("header.editOccurrences")}
        >
          <div className="createAgenda">
            <Select
              className="createAgendaSelect"
              label={t("header.typeOfVisit")}
              onChange={(e) => handleChangeTypeOfVisit(e.value)}
              options={typeofAppointmentData}
              value={typeOfVisit}
              onClear={() => onClearTypeOfVisit()}
              disabled={true}
              readOnly
            />

            <Select
              className="createAgendaSelect"
              label={t("header.subRetail")}
              onChange={(e) => handleChangeSubRetail(e.value)}
              options={subretailData}
              value={subRetail}
              onClear={() => onClearSubRetail()}
            />

            <Select
              className="createAgendaSelect"
              label={t("header.pointOfSale")}
              onChange={(e) => setPointOfSale([e.value])}
              options={pointOfSaleData.map(truncatePosLabel)}
              value={pointOfSale}
              onClear={() => setPointOfSale([])}
              error={errorPos}
            />

            <DatePicker
              className="createAgendaSelect createAgendaDatePicker"
              clearIcon={false}
              orientation="horizontal"
              range
              startDatePlaceholder="mm/dd/yyyy"
              endDatePlaceholder="mm/dd/yyyy"
              format="LL"
              startDate={startDate}
              endDate={endDate}
              startDateLabel={t("header.stardDate")}
              endDateLabel={t("header.endDate")}
              disabled={true}
            />

            <div className="agendaTimesErrorBlock">
              {occStartTimeErrorReason && (
                <p className="agendaTimePickerError">
                  {occStartTimeErrorReason === 'minTime'
                    ? t("header.startTimePastError")
                    : t("header.startTimeInvalidError")}
                </p>
              )}
              {(occEndTimeErrorReason || timesAreEqual) && (
                <p className="agendaTimePickerError">{endTimeErrorMessage}</p>
              )}
            </div>

            <div className="createAgendaTimes">
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <ThemeProvider theme={theme}>
                  <div className="agendaTimePickerCell">
                    <TimePicker
                      className="createAgendaTimePicker"
                      label={t("header.startTime")}
                      value={startTime}
                      onChange={(value) => setStartTime(value)}
                      onError={(reason) => setOccStartTimeErrorReason(reason ?? null)}
                      renderInput={(params) => <TextField {...params} />}
                      minutesStep={5}
                      ampm={false}
                      minTime={isOccurrenceTodayForEdit ? moment() : undefined}
                    />
                  </div>

                  <div className="agendaTimePickerCell">
                    <TimePicker
                      className="createAgendaTimePicker"
                      label={t("header.endTime")}
                      minTime={startTime}
                      value={endTime}
                      onChange={(value) => setEndTime(value)}
                      onError={(reason) => setOccEndTimeErrorReason(reason ?? null)}
                      renderInput={(params) => (
                        <TextField {...params} error={params.error || timesAreEqual} />
                      )}
                      minutesStep={5}
                      ampm={false}
                    />
                  </div>
                </ThemeProvider>
              </LocalizationProvider>
            </div>

            <div className="createAgendaDays createAgendaDaysScrollable">
              {occurrenceOptions.map((occurrence) => {
                const value = String(occurrence.value);
                const isChecked = selectedOccurrenceDates.includes(value);

                return (
                  <Checkbox
                    key={value}
                    className="createAgendaCheckbox"
                    label={String(occurrence.label)}
                    checked={isChecked}
                    disabled={value !== currentEditOccurrenceValue}
                    onChange={() => {
                      if (isChecked) {
                        setSelectedOccurrenceDates((prev) =>
                          prev.filter((x) => x !== value)
                        );
                      } else {
                        setSelectedOccurrenceDates((prev) => [...prev, value]);
                      }
                    }}
                  />
                );
              })}
            </div>
          </div>
        </Modal>
      </div>

      {/* Modal Messages*/}
      <div className="modalRelativeContainer">
        <ModalMessageAgenda
          openModal={openMessageCreatedAgenda}
          closeModal={setOpenMessageCreatedAgenda}
          title={t("modal.message")}
          message={t("modal.agendaCreated")}
        />
      </div>

      <div className="modalRelativeContainer">
        <ModalMessageAgenda
          openModal={openMessageError}
          closeModal={setOpenMessageError}
          title={t("modal.message")}
          message={t("modal.generalError")}
        />
      </div>

      <div className="modalRelativeContainer">
        <ModalMessageAgenda
          openModal={openMessageExistingAgenda}
          closeModal={setOpenMessageExistingAgenda}
          title={t("modal.message")}
          message={t("modal.existingAgenda")}
        />
      </div>

      <div className="modalRelativeContainer">
        <ModalMessageAgenda
          openModal={openMessageUpdateAgenda}
          closeModal={setOpenMessageUpdateAgenda}
          title={t("modal.message")}
          message={t("modal.updateInfo")}
        />
      </div>

      <div className="modalRelativeContainer">
        <ModalMessageAgenda
          openModal={openMessageExpiredAgenda}
          closeModal={setOpenMessageExpiredAgenda}
          title={t("modal.message")}
          message={t("modal.expiredAgenda")}
        />
      </div>

      <div className="modalRelativeContainer">
        <ModalMessageAgenda
          openModal={openMessageDeleteAgenda}
          closeModal={setOpenMessageDeleteAgenda}
          title={t("modal.message")}
          message={t("modal.deleteAgenda")}
        />
      </div>

      <div className="modalRelativeContainer">
        <ModalMessageAgenda
          openModal={openMessageToDeleteAgendaWithCheckIn}
          closeModal={setOpenMessageToDeleteAgendaWithCheckIn}
          title={t("modal.message")}
          message={t("modal.deleteAgendaWithCheckIn")}
        />
      </div>

      <div className="modalRelativeContainer">
        <ModalMessageAgenda
          openModal={openMessageStartDateError}
          closeModal={setOpenMessageStartDateError}
          title={t("modal.message")}
          message={t("header.errorstartDate")}
        />
      </div>

      <div className="modalRelativeContainer">
        <ModalMessageAgenda
          openModal={openMessagePastOccurrenceRestricted}
          closeModal={setOpenMessagePastOccurrenceRestricted}
          title={t("modal.message")}
          message={t("modal.pastOccurrenceEditRestricted")}
        />
      </div>

      <div className="modalRelativeContainer">
        <ModalMessageAgenda
          openModal={openMessageCheckedInRestricted}
          closeModal={setOpenMessageCheckedInRestricted}
          title={t("modal.message")}
          message={t("modal.checkedInOccurrenceEditRestricted")}
        />
      </div>

      <WeeklyAgendaModal
        show={showModalWeeklyAgenda}
        onClose={() => setShowModalWeeklyAgenda(false)}
        userID={valueAdviser[0] ?? 0}
        onCreated={() => { getAppointmentsByUser(valueAdviser[0], languageID.value); setOpenMessageCreatedAgenda(true); }}
        onPartialCreated={() => getAppointmentsByUser(valueAdviser[0], languageID.value)}
        onError={() => setOpenMessageError(true)}
        onAllFailed={() => setOpenMessageExistingAgenda(true)}
      />
    </div>
  );
}
